// api/pages.js
const API_BASE_URL = process.env.VITE_API_BASE_URL || "https://prod.getrevibe.app/api";

export const pagesApi = {
  // Fetch all pages with pagination
  getAllPages: async (page = 1, limit = 10, search = "") => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/pages?sortOrder=desc&page=${page}&limit=${limit}&search=${search}`
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return { success: true, data };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Fetch single page by slug
  getPageBySlug: async (slug) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/pages?sortOrder=desc&page=1&limit=100&search=`
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      const page = data.pages?.find((p) => p.slug === slug);
      
      if (!page) {
        throw new Error(`Page with slug "${slug}" not found`);
      }
      
      return { success: true, data: page };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Fetch multiple specific pages by slugs
  getPagesBySlugs: async (slugs) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/pages?sortOrder=desc&page=1&limit=100&search=`
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      const pages = slugs.reduce((acc, slug) => {
        const page = data.pages?.find((p) => p.slug === slug);
        if (page) acc[slug] = page;
        return acc;
      }, {});
      
      return { success: true, data: pages };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }
};